import Swiper from 'swiper';

// set jQuery
const $ = window.jQuery;

// start event handlers
$(document).on('ready', function() {
  itemSectionSelect();
  itemSectionScroll();

  new Swiper('.kn-content-section-7 .swiper-container', {
    freeMode: true,
    slidesPerView: 'auto',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  });
});

$(window).on('scroll', function () {
  itemSectionScroll();
});

$(".flowbox-menu").on('click', function(event){
  $('.flowbox-menu').removeClass("active");
  $(this).addClass("active");
  $('.item').removeClass("active");
  $('#item-'+$(this).attr('id')).find(".aos-animate").each(function(){
    $(this).removeClass("aos-animate").removeClass("aos-init");
  });
  $('#item-'+$(this).attr('id')).addClass("active");
  window.scrollTo(0, window.scrollY + 2);
});

function itemSectionSelect() {
  $('.item').each(function (index, slider) {

  });
}

function itemSectionScroll() {
}